// Google Analytics 4 (gtag) — carrega só se VITE_GA_MEASUREMENT_ID estiver
// configurado. Em ambientes sem o ID (dev, branch preview), vira no-op.
// Documentação: https://developers.google.com/analytics/devguides/collection/ga4

const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || '';

let bootstrapped = false;
export function initAnalytics() {
  if (bootstrapped || typeof window === 'undefined' || !GA_ID) return;
  bootstrapped = true;
  try {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_ID, { send_page_view: true });
  } catch {
    /* analytics não pode quebrar o app */
  }
}

// Eventos custom. Use nomes consistentes em snake_case.
// Exemplos: signup_completed, onboarding_completed, gift_created, gift_purchased,
// rsvp_submitted, payout_requested.
export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined' || !window.gtag) return;
  try { window.gtag('event', String(name || 'unknown_event'), params); } catch { /* noop */ }
}

// Helper pra paginação SPA (rastrear navegação cliente-side).
export function trackPageView(path) {
  if (typeof window === 'undefined' || !window.gtag || !GA_ID) return;
  try {
    window.gtag('config', GA_ID, {
      page_path: path || window.location.pathname + window.location.search,
    });
  } catch { /* noop */ }
}
